export default {
    "title": "Transportes / {{client}}",
    "description": "Listado de transportes",
    "filters": {
        "transportCode": "Cod. Transporte",
        "material": "Material",
        "status": "Estado",
        "statusAll": "Todos"
    },
    "statuses": {
        "0": "Inicial",
        "1": "En curso",
        "2": "En curso",
        "3": "En curso",
        "4": "Concluido",
        "other": "Otro"
    },
    "transportationTableColumns": {
        "departure_date": "Fecha salida",
        "planned_arrival": "Fecha planificada de llegada",
        "actual_arrival": "Fecha de llegada",
        "transport_code": "Cod. Transporte",
        "material": "Material",
        "status": "Estado",
        "location": "Localización",
        "description": "Descripción",
    },
    "transport": "Transporte",
    "materials": "materiales",
    "viewLocation": "Ver mapa",
    "lastUpdate": "Última actualización",
    "refresh": "Actualizar",
    "refreshing": "Actualizando…",
    "tracking": "Seguimiento del transporte",
    "currentStatus": "Estado actual",
    "inTransitDescription": "El vehículo se encuentra en camino a su destino.",
    "notStartedDescription": "El vehículo aún no ha salido.",
    "arrivedDescription": "El vehículo ha llegado a su destino.",
    "driver": "Conductor",
    "contactPhone": "Teléfono de contacto",
    "origin": "Origen",
    "scheduleNotice": "Los horarios son estimados y pueden variar según las condiciones del tráfico.",
    "plannedArrival": "Llegada planificada",
    "deliveryDue": "Entrega prevista",
    "actualArrival": "Llegada al cliente",
    "destination": "Destino",
    "truck": "Camión",
    "shipmentSummary": "Resumen del envío",
    "noCoordinates": "No hay coordenadas disponibles para este transporte.",
    "close": "Cerrar",
    "noDate": "Sin fecha",
    "nameCollection": "transportes",
    "results": "resultados",
    "realTimeInfo": "Información en tiempo real del envío"
}
